// extracted by mini-css-extract-plugin
export default {"tooltip":"AQ-z","arrow":"BQ-z"};